<!-- TODO: mover la logica de inmeeting componente del elemento dialógico aquí -->
<template>
  <div>
    <div class="modern-card" :class="{ 'blocked-card': element.blocked }">
      <!-- Header del elemento -->
      <div class="modern-card-header">
        <v-avatar size="50" class="mr-3" :style="{ objectFit: 'cover' }">
          <img :src="getUserById(element.writer)?.avatar ?? this.$store.state.defaultAvatar" alt="Avatar"
            width="100%" />
        </v-avatar>
        <div>
          <div class="modern-card-author">{{ getNameUserFromId(element.writer) || 'No definido.' }}</div>
          <div class="modern-card-meta">{{ topic }}.{{ element.number }} -
            <v-chip :color="getLozengeClass(element.type)" dark small class="ml-2">
              {{ element.type }}
            </v-chip>
          </div>
          <div class="modern-card-timestamp">
            {{ element.createdAt ? new Date(element.createdAt).toLocaleString() : 'Fecha desconocida' }}
          </div>
        </div>
      </div>

      <!-- Contenido markdown -->
      <div class="modern-card-content text-wrap" style="padding: 0px 16px;">
        <div v-html="renderMarkdown(element.description)" class="markdown-content"></div>
      </div>

      <!-- Botonera -->
      <div class="modern-card-actions">
        <template v-if="showVotingButtons">
          <!-- Votar SI -->
          <v-btn icon small @click="voteElement(element, 'si')" :disabled="element.blocked || mode !== 'in-meeting'"
          :class="{pressed: isVoteButtonPressed('si') }">
            <v-icon small>mdi-thumb-up</v-icon>
          </v-btn>
          <span>{{ element.si }}</span>

          <!-- Votar NO -->
          <v-btn icon small @click="voteElement(element, 'no')" :disabled="element.blocked || mode !== 'in-meeting'"
          :class="{pressed: isVoteButtonPressed('no') }">
            <v-icon small>mdi-thumb-down</v-icon>
          </v-btn>
          <span>{{ element.no }}</span>
        </template>

        <!-- Editar elemento -->
        <template v-if="!element.blocked && mode !== 'finish'">
            <!-- Editar elemento -->
            <v-tooltip location="bottom">
            <template #activator="{ props }">
              <v-btn icon small color="primary" @click="editElement" v-bind="props">
              <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar elemento</span>
            </v-tooltip>

            <!-- Escribir desacuerdo a este elemento -->
            <v-tooltip location="bottom" v-if="isInMeeting">
            <template #activator="{ props }">
              <v-btn icon small color="secondary" @click="disagreement" :disabled="element.blocked" v-bind="props">
              <v-icon small>mdi-chat-minus</v-icon>
              </v-btn>
            </template>
            <span>Desacuerdo</span>
            </v-tooltip>

            <!-- Eliminar elemento dialógico -->
            <v-tooltip location="bottom">
            <template #activator="{ props }">
              <v-btn icon small color="error" @click="deleteElement" v-bind="props">
              <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar elemento</span>
            </v-tooltip>

          <!-- Crear un subproyecto a partir del elemento -->
          <v-tooltip location="bottom">
            <template #activator="{ props }">
              <v-btn
                icon
                small
                color="success"
                @click="showNewSubprojectDialog = true"
                v-bind="props"
                v-if="hasSubProjectFromCommitment && element.type === 'compromiso'"
              >
                <v-icon small>mdi-account-group</v-icon>
              </v-btn>
            </template>
            <span>crear {{ project.subprojectName }}</span>
          </v-tooltip>
        </template>
      </div>
    </div>

    <NewSubproject v-model:dialog="showNewSubprojectDialog" v-if="showNewSubprojectDialog" />
  </div>
</template>

<script>
import { marked } from 'marked'; // Importar la librería para procesar Markdown
import { getLozengeClass } from '@/utils/globalFunctions';
import api from '@/api.js';
import NewSubproject from '../modals/NewSubproject.vue';

export default {
  name: 'ElementComponent',
  components: {
    NewSubproject,
  },
  props: {
    mode: {
      type: String,
      default: 'in-meeting',
    },
    topic: {
      type: Number,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
  },
  computed: {
    users() {
      return this.$store.state.users_map;
    },
    meeting(){
      return this.$store.state.meeting;
    },
    project(){
      return this.$store.state.project;
    },
    canVote(){
      return this.project?.options?.useVoting || false;
    },
    isVotacion(){
      return this.element.type === 'votación' || this.element.type === 'votacion';
    },
    isInMeeting(){
      return this.mode === 'in-meeting';
    },
    showVotingButtons(){
      // Si la app permite las votaciones
      // y el elemento es de tipo votación
      // Y está en inmeeting
      // console.log('showVotingButtons', this.canVote, this.isVotacion, this.isInMeeting);
      return this.canVote && this.isVotacion;
    },
    hasSubProjectFromCommitment() {
      return this.$store.state.project?.options?.hasSubprojectsFromCommitment;
    },
  },
  data(){
    return {
      showNewSubprojectDialog: false,
    }
  },
  methods: {
    isVoteButtonPressed(option){
      return this.element.user_vote.find(e => e.email === localStorage.getItem('email'))?.vote === option
    },
    disagreement() {
      this.$emit('disagreement', this.element);
    },
    async deleteElement() {
      try {
        await api.delete(`/api/element/${this.element._id}`);

        // Emitir el evento
        this.$socket.emit('event_delete_element', {
          room: this.meeting._id,
          user: localStorage.getItem('email'),
          element: this.element
        });
        this.$store.commit('setSnackbar', { text: 'Elemento eliminado correctamente', color: 'success', icon: 'mdi-check' });
      } catch (e) {
        console.log(e);
        this.$store.commit('setSnackbar', { text: 'Error al eliminar el elemento', color: 'error', icon: 'mdi-alert' });
      }
    },
    getLozengeClass,
    getUserById(id) {
      return this.users?.get(id) || null;
    },
    getNameUserFromId(id) {
      return this.users?.get(id)?.name.split(' ')[0] || 'Usuario no especificado.';
    },
    renderMarkdown(content) {
      return marked(content); // Convierte el texto de Markdown a HTML
    },
    voteElement(element, vote) {
      const userEmail = localStorage.getItem('email');

      // Si el elemento no tiene un array de votos, lo inicializamos
      if (!element.user_vote) {
        element.user_vote = [];
      }

      // Si el usuario no ha votado, lo añadimos al array de votos
      if (!element.user_vote.find(e => e.email === userEmail)) {
        const output = {
          email: userEmail,
          vote: vote
        }
        element.user_vote.push(output);
        vote === 'si' ? element.si++ : element.no++;
      }

      else{
        // Si el usuario ya ha votado, actualizamos su voto
        // Si vota lo mismo, lo eliminamos
        // Si vota diferente, lo cambiamos
        const userVote = element.user_vote.find(e => e.email === userEmail);
        if (userVote.vote === vote) {
          element.si = vote === 'si' ? element.si - 1 : element.si;
          element.no = vote === 'no' ? element.no - 1 : element.no;
          element.user_vote = element.user_vote.filter(e => e.email !== userEmail);
        } else {
          userVote.vote = vote;
          vote === 'si' ? (element.si++, element.no--) : (element.no++, element.si--);
        }
      }

      // this.updateElementBackend(element);
      this.$emit('updateElement', element);
    },
    editElement(){
      this.$emit('edit')
    }
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modern-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  user-select: none;
}

.modern-card-author {
  font-weight: bold;
  font-size: large;
}

.modern-card-meta {
  font-weight: bold;
  font-size: large;
  /* color: #757575; */
}

.modern-card-timestamp {
  font-size: small;
  color: #9e9e9e;
  margin-top: 4px;
}

.modern-card-content {
  margin: 8px 0;
  font-size: large;
  line-height: 1.5;
}

.modern-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.blocked-card {
  background-color: #f5f5f5;
  border: 1px solid #d6d6d6;
  opacity: 0.7;
  pointer-events: none;
}

.blocked-card .modern-card-actions {
  pointer-events: auto;
  /* Permitir interacción con botones de votación */
}

.markdown-content {
  word-wrap: break-word;
  white-space: normal;
}

.text-wrap {
  word-wrap: break-word;
  white-space: normal;
}

.pressed{
  background-color: rgb(114, 255, 140);
}
</style>